// extracted by mini-css-extract-plugin
export default {"tagListContainer":"tagList_tagListContainer__AMNTE","container":"tagList_container__Awdr+","actionButtons":"tagList_actionButtons__UrvPw"};